module.exports = __webpack_public_path__ + "static/media/TN-Women-Dress-Rakuten.d4a16a32.svg";